import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { AlarmBanner } from '../Alarms/AlarmBanner';
import { Icons } from '../Icons';
import { useParks } from '../../contexts/ParksContext';

// Põhiline rakenduse paigutus: külgriba + põhisisu.
// AlarmBanner kogub alarmid kõigist parkidest (ParksContext).
export function Layout({ connected }) {
  const { data } = useParks();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  // Loendame kogu süsteemi aktiivsed alarmid (sidebar nupu badge'i jaoks).
  // Käime üle KÕIK konfigureeritud pargid (name olemas), mitte ainult online'id.
  let alarmCount = 0;
  if (data?.parks) {
    for (const p of data.parks) {
      if (!p.name) continue;  // placeholder pargid, pole konfis
      if (p.disabled || p.muted) continue;  // disabled/muted pargid ei lekita badge'i
      // Markedroidi-üleandmine: ex9EMS / inverter pollimine kavatsuslikult off — ära loe alarmiks
      const ex9emsHandover = p.control?.pcs_polling_disabled === true;
      const inverterHandover = p.control?.inverter_polling_disabled === true;
      // Ühenduse-puudumise alarmid (per seade) — host konfis aga andmeid pole/vana
      if (!ex9emsHandover) {
        if (p.host && (!p.solar || p.solar._online === false)) alarmCount += 1;
        if (p.host && (!p.grid || p.grid._online === false)) alarmCount += 1;
        if (p.pcs_host && (!p.pcs || p.pcs._online === false)) alarmCount += 1;
      }
      if (p.bau_host && (!p.bau || p.bau._online === false)) alarmCount += 1;
      // Inverterite alarmid — skipi kui inverter_polling_disabled
      if (Array.isArray(p.inverters) && !inverterHandover) {
        for (const inv of p.inverters) {
          if (!inv._updated_at || inv._online === false) alarmCount += 1;
          else if (inv.work_mode === 2 || inv.error_word) alarmCount += 1;  // critical
          else if (inv.warning_code) alarmCount += 1;                        // warning
        }
      }
      // BAU bittide tasandi alarmid
      if (p.bau) {
        if (Array.isArray(p.bau.active_alarms)) {
          alarmCount += p.bau.active_alarms.filter(
            (a) => a.severity === 'critical' || a.severity === 'warning'
          ).length;
        }
        if (Array.isArray(p.bau.lc_active_faults)) {
          alarmCount += p.bau.lc_active_faults.length;
        }
        if (p.bau.tempAndSmokeAlarm) alarmCount += 1;
      }
    }
  }

  return (
    <div className="flex h-screen bg-slate-50 layout-root">
      {/* Globaalne SVG ikoonide library — peidetud */}
      <Icons />

      {/* Mobile-only hamburger nupp */}
      <button
        type="button"
        className="mobile-nav-toggle"
        onClick={() => setMobileNavOpen(true)}
        aria-label="Ava menüü"
      >
        <Menu size={22} />
      </button>

      {/* Backdrop kui mobiilne sidebar avatud */}
      {mobileNavOpen && (
        <div
          className="mobile-nav-backdrop"
          onClick={() => setMobileNavOpen(false)}
        />
      )}

      <div className={`sidebar-wrapper${mobileNavOpen ? ' open' : ''}`}>
        <Sidebar connected={connected} alarmCount={alarmCount} onNavigate={() => setMobileNavOpen(false)} />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden main-wrapper">
        <AlarmBanner />

        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;
